import { IKON_MODAL } from './ikonModal';
import { IAppState } from '../redux/IAppState';
import { Action } from 'redux';
import { ACTION_TYPE } from '../redux/actionType';
import { assoc } from '../../language/module';


type ShowModalAction = {
  type: ACTION_TYPE.SHOW_MODAL,
  modalType: IKON_MODAL,
  extras?: any,
}


/**
 * Shows a modal with the given parameters. See ModalHost to see how this data is mapped into a specific modal.
 * @param modalType - the modal to show
 * @param extras - an object to pass the modal (the object is usually destructured into the component's props). Keep in
 *                 mind that this object is going into app state, so don't add anything that can't be JSON serialized or
 *                 JSON deserialized e.g. functions.
 */
export const showModalAction = (modalType: IKON_MODAL, extras?: any): ShowModalAction => ({
  type:      ACTION_TYPE.SHOW_MODAL,
  modalType: modalType,
  extras:    extras,
});


export const showModalReducer = (state: IAppState, action: Action): IAppState => {
  if (action.type !== ACTION_TYPE.SHOW_MODAL) {
    return state;
  }

  const modalAction = action as ShowModalAction;

  return assoc('currentModal', { type: modalAction.modalType, extras: modalAction.extras }, state);
};
